import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, ListGroup, Badge, Alert, Spinner, Nav, Tab, Container } from 'react-bootstrap';
import ChatQueja from './ChatQueja';
import './QuejaModal.css';

const QuejaModal = ({
    show,
    onHide,
    selectedQueja,
    quejasCompletas,
    setQuejasCompletas,
    obtenerTextoTipo,
    obtenerColorEstado,
    obtenerTextoEstado,
    formatearFecha,
    descargarEvidencia,
    marcarComoResuelta,
    setQuejas,
    setQuejasFiltradas,
    setSelectedQueja,
}) => {
    const [contactos, setContactos] = useState([]);
    const [contactosFiltrados, setContactosFiltrados] = useState([]);
    const [mostrarBuscador, setMostrarBuscador] = useState(false);
    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [contactoSeleccionado, setContactoSeleccionado] = useState(null);
    const [mensajePersonalizado, setMensajePersonalizado] = useState('');
    const [fechaLimite, setFechaLimite] = useState('');
    const [enviando, setEnviando] = useState(false);
    const [mensajeExito, setMensajeExito] = useState('');
    const [mensajeError, setMensajeError] = useState('');
    const [cargandoContactos, setCargandoContactos] = useState(false);
    const [buscando, setBuscando] = useState(false);
    const [marcando, setMarcando] = useState(false);
    const [editandoFechaLimite, setEditandoFechaLimite] = useState(false);
    const [nuevaFechaLimite, setNuevaFechaLimite] = useState('');
    const [actualizandoFecha, setActualizandoFecha] = useState(false);
    const [fechaLimiteOriginal, setFechaLimiteOriginal] = useState('');
    const [usuarioRol, setUsuarioRol] = useState('admin');
    const [mensajesChat, setMensajesChat] = useState([]);
    const [cargandoChat, setCargandoChat] = useState(false);
    const [hasRespondido, setHasRespondido] = useState(false);
    const [activeTab, setActiveTab] = useState('info');
    const [archivoAdjunto, setArchivoAdjunto] = useState(null);
    const [archivoNombre, setArchivoNombre] = useState('');

    useEffect(() => {
        const usuario = JSON.parse(localStorage.getItem('usuario'));
        if (usuario && usuario.rol) {
            setUsuarioRol(usuario.rol);
        }
    }, []);

    useEffect(() => {
        if (show && selectedQueja) {
            if (quejasCompletas[selectedQueja.id]?.fecha_limite) {
                const fecha = new Date(quejasCompletas[selectedQueja.id].fecha_limite);
                const fechaFormateada = fecha.toISOString().slice(0, 16);
                setFechaLimiteOriginal(fechaFormateada);
                setNuevaFechaLimite(fechaFormateada);
            } else {
                setFechaLimiteOriginal('');
                setNuevaFechaLimite('');
            }
            setEditandoFechaLimite(false);
            cargarMensajesChat();
        }
    }, [show, selectedQueja, quejasCompletas]);

    useEffect(() => {
        if (!show) {
            setContactoSeleccionado(null);
            setMensajePersonalizado('');
            setFechaLimite('');
            setTerminoBusqueda('');
            setMensajeError('');
            setMensajeExito('');
            setMostrarBuscador(false);
            setEditandoFechaLimite(false);
            setNuevaFechaLimite('');
            setActualizandoFecha(false);
            setActiveTab('info');
        }
    }, [show]);

    useEffect(() => {
        if (mostrarBuscador) {
            if (!contactos || contactos.length === 0) {
                cargarContactosMicrosoft();
            } else {
                setContactosFiltrados(contactos);
            }
        }
    }, [mostrarBuscador]);

    useEffect(() => {
        if (terminoBusqueda && terminoBusqueda.length >= 2) {
            const timeout = setTimeout(() => {
                buscarContactos(terminoBusqueda);
            }, 300);
            return () => clearTimeout(timeout);
        } else {
            setContactosFiltrados(contactos);
        }
    }, [terminoBusqueda, contactos]);

    const cargarMensajesChat = async () => {
        if (!selectedQueja) return;
        try {
            setCargandoChat(true);
            const token = localStorage.getItem('token');
            const response = await fetch(`https://api-sugerencias.conduto.com.ec/chat/${selectedQueja.id}/mensajes`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error('Error al cargar mensajes del chat');
            const result = await response.json();
            if (result.success) {
                setMensajesChat(result.data);
                const hasEncargadoRespondido = result.data.some(msg => msg.usuario_rol === 'encargado');
                setHasRespondido(hasEncargadoRespondido);
            }
        } catch (error) {
            console.error('Error al cargar mensajes del chat:', error);
        } finally {
            setCargandoChat(false);
        }
    };

    const cargarContactosMicrosoft = async () => {
        try {
            setCargandoContactos(true);
            setMensajeError('');
            const token = localStorage.getItem('token');
            const response = await fetch('https://api-sugerencias.conduto.com.ec/contactos-microsoft', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) {
                throw new Error('Error al cargar los contactos de Microsoft');
            }
            const result = await response.json();
            if (result.success) {
                setContactos(result.data);
                setContactosFiltrados(result.data);
            } else {
                throw new Error(result.message);
            }
        } catch (error) {
            console.error('Error al cargar contactos Microsoft:', error);
            setMensajeError('Error al cargar la lista de contactos de Microsoft');
        } finally {
            setCargandoContactos(false);
        }
    };

    const buscarContactos = async (termino) => {
        try {
            setBuscando(true);
            const token = localStorage.getItem('token');
            const response = await fetch(`https://api-sugerencias.conduto.com.ec/buscar-contactos?termino=${encodeURIComponent(termino)}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) {
                throw new Error('Error al buscar contactos');
            }
            const result = await response.json();
            if (result.success) {
                setContactosFiltrados(result.data);
            } else {
                throw new Error(result.message);
            }
        } catch (error) {
            console.error('Error al buscar contactos:', error);
            const filtrados = contactos.filter(contacto =>
                contacto.nombre.toLowerCase().includes(termino.toLowerCase()) ||
                contacto.correo.toLowerCase().includes(termino.toLowerCase()) ||
                (contacto.oficina && contacto.oficina.toLowerCase().includes(termino.toLowerCase()))
            );
            setContactosFiltrados(filtrados);
        } finally {
            setBuscando(false);
        }
    };

    const enviarQuejaAContacto = async () => {
        if (!selectedQueja || !selectedQueja.id) {
            const tipoTexto = selectedQueja?.tipo_queja === 'identificada' ? 'sugerencia' : 'denuncia';
            setMensajeError(`No hay ${tipoTexto} seleccionada`);
            return;
        }

        if (!contactoSeleccionado || !contactoSeleccionado.nombre || !contactoSeleccionado.correo) {
            setMensajeError('Por favor selecciona un contacto válido');
            return;
        }

        try {
            setEnviando(true);
            setMensajeError('');
            const token = localStorage.getItem('token');
            if (!token) {
                localStorage.removeItem('token');
                localStorage.removeItem('usuario');
                window.location.href = '/administrador/login';
                return;
            }

            const quejaId = parseInt(selectedQueja.id);
            if (isNaN(quejaId)) {
                throw new Error('ID de sugerencia inválido');
            }

            console.log('Enviando queja ID:', quejaId);

            const formData = new FormData();
            formData.append('contactoId', contactoSeleccionado.id || '');
            formData.append('contactoNombre', contactoSeleccionado.nombre || '');
            formData.append('contactoCorreo', contactoSeleccionado.correo || '');
            formData.append('contactoOficina', contactoSeleccionado.oficina || '');
            formData.append('mensajePersonalizado', mensajePersonalizado || '');
            formData.append('fechaLimite', fechaLimite || '');

            if (archivoAdjunto) {
                formData.append('archivoAdjunto', archivoAdjunto);
            }

            const url = `https://api-sugerencias.conduto.com.ec/queja/${quejaId}/enviar-contacto`;
            console.log('URL de petición:', url);

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData
            });

            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('usuario');
                window.location.href = '/administrador/login';
                return;
            }

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Error al enviar la queja');
            }

            if (result.success) {
                setMensajeExito(`Sugerencia enviada correctamente a ${contactoSeleccionado.nombre}`);

                if (setQuejas && setQuejasFiltradas) {
                    setQuejas(prev => prev.map(q =>
                        q.id === quejaId ? {
                            ...q,
                            estado: 'en_proceso',
                            fecha_actualizacion: result.data.fechaActualizacion,
                            asignada_a: contactoSeleccionado.nombre,
                            contacto_asignado: contactoSeleccionado.nombre,
                            contacto_correo: contactoSeleccionado.correo || '',
                            fecha_limite: result.data.fechaLimite
                        } : q
                    ));
                    setQuejasFiltradas(prev => prev.map(q =>
                        q.id === quejaId ? {
                            ...q,
                            estado: 'en_proceso',
                            fecha_actualizacion: result.data.fechaActualizacion,
                            asignada_a: contactoSeleccionado.nombre,
                            contacto_asignado: contactoSeleccionado.nombre,
                            contacto_correo: contactoSeleccionado.correo || '',
                            fecha_limite: result.data.fechaLimite
                        } : q
                    ));
                }

                if (setSelectedQueja) {
                    setSelectedQueja(prev => ({
                        ...prev,
                        estado: 'en_proceso',
                        fecha_actualizacion: result.data.fechaActualizacion,
                        asignada_a: contactoSeleccionado.nombre,
                        contacto_asignado: contactoSeleccionado.nombre,
                        contacto_correo: contactoSeleccionado.correo || '',
                        fecha_limite: result.data.fechaLimite
                    }));
                }

                cargarMensajesChat();

                setContactoSeleccionado(null);
                setMensajePersonalizado('');
                setFechaLimite('');
                setArchivoAdjunto(null);
                setArchivoNombre('');
                setMostrarBuscador(false);
            } else {
                throw new Error(result.message);
            }
        } catch (error) {
            console.error('Error al enviar sugerencia:', error);
            setMensajeError(error.message);
        } finally {
            setEnviando(false);
        }
    };

    const handleMarcarComoResuelta = async (id) => {
        try {
            setMarcando(true);
            setMensajeError('');

            if (marcarComoResuelta) {
                await marcarComoResuelta(id);
            } else {
                const token = localStorage.getItem('token');
                const response = await fetch(`https://api-sugerencias.conduto.com.ec/queja/${id}/estado`, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ estado: 'resuelta' })
                });
                if (!response.ok) {
                    const result = await response.json().catch(() => ({}));
                    throw new Error(result.message || 'Error al actualizar estado');
                }
            }

            const fechaActualizacion = new Date().toISOString();

            if (setSelectedQueja) {
                setSelectedQueja(prev => ({
                    ...prev,
                    estado: 'resuelta',
                    fecha_actualizacion: fechaActualizacion
                }));
            }

            setQuejasCompletas(prev => ({
                ...prev,
                [id]: {
                    ...(prev[id] || {}),
                    estado: 'resuelta',
                    fecha_actualizacion: fechaActualizacion
                }
            }));

            if (setQuejas && setQuejasFiltradas) {
                setQuejas(prev => prev.map(q =>
                    q.id === id ? { ...q, estado: 'resuelta', fecha_actualizacion: fechaActualizacion } : q
                ));
                setQuejasFiltradas(prev => prev.map(q =>
                    q.id === id ? { ...q, estado: 'resuelta', fecha_actualizacion: fechaActualizacion } : q
                ));
            }

            setMensajeExito('Sugerencia marcada como resuelta correctamente');

            setTimeout(() => {
                if (selectedQueja) {
                    cargarMensajesChat();
                }
            }, 1500);

            setTimeout(() => {
                setMensajeExito('');
            }, 3000);

        } catch (error) {
            console.error('Error al marcar como resuelta:', error);
            setMensajeError(error.message);
        } finally {
            setMarcando(false);
        }
    };

    const seleccionarContacto = (contacto) => {
        if (contacto && contacto.nombre && contacto.correo) {
            setContactoSeleccionado(contacto);
            setTerminoBusqueda('');
        } else {
            setMensajeError('Contacto inválido seleccionado');
        }
    };

    const limpiarSeleccion = () => {
        setContactoSeleccionado(null);
        setMensajePersonalizado('');
        setFechaLimite('');
        setArchivoAdjunto(null);
        setArchivoNombre('');
        setTerminoBusqueda('');
    };

    const resetearBuscador = () => {
        setMostrarBuscador(false);
        setContactoSeleccionado(null);
        setMensajePersonalizado('');
        setFechaLimite('');
        setArchivoAdjunto(null);
        setArchivoNombre('');
        setTerminoBusqueda('');
        setMensajeError('');
        setMensajeExito('');
    };

    const handleArchivoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setMensajeError('El archivo es demasiado grande. El tamaño máximo es 5MB.');
                e.target.value = '';
                return;
            }
            setArchivoAdjunto(file);
            setArchivoNombre(file.name);
        }
    };

    const actualizarFechaLimite = async () => {
        if (!selectedQueja) return;
        try {
            setActualizandoFecha(true);
            setMensajeError('');
            const token = localStorage.getItem('token');
            if (!token) {
                localStorage.removeItem('token');
                localStorage.removeItem('usuario');
                window.location.href = '/administrador/login';
                return;
            }
            const response = await fetch(`https://api-sugerencias.conduto.com.ec/queja/${selectedQueja.id}/fecha-limite`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    fechaLimite: nuevaFechaLimite || null
                })
            });
            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('usuario');
                window.location.href = '/administrador/login';
                return;
            }
            const result = await response.json();
            if (!response.ok) {
                throw new Error(result.message || 'Error al actualizar fecha límite');
            }
            if (setQuejas && setQuejasFiltradas) {
                const fechaActualizacion = result.data?.fechaActualizacion || new Date().toISOString();
                setQuejas(prev => prev.map(q =>
                    q.id === selectedQueja.id ? {
                        ...q,
                        fecha_limite: nuevaFechaLimite || null,
                        fecha_actualizacion: fechaActualizacion
                    } : q
                ));
                setQuejasFiltradas(prev => prev.map(q =>
                    q.id === selectedQueja.id ? {
                        ...q,
                        fecha_limite: nuevaFechaLimite || null,
                        fecha_actualizacion: fechaActualizacion
                    } : q
                ));
            }
            if (setSelectedQueja) {
                setSelectedQueja(prev => ({
                    ...prev,
                    fecha_limite: nuevaFechaLimite || null
                }));
            }
            setQuejasCompletas(prev => ({
                ...prev,
                [selectedQueja.id]: {
                    ...(prev[selectedQueja.id] || {}),
                    fecha_limite: nuevaFechaLimite || null
                }
            }));
            setMensajeExito('Fecha límite actualizada correctamente');
            setFechaLimiteOriginal(nuevaFechaLimite);
            setEditandoFechaLimite(false);
            setTimeout(() => {
                setMensajeExito('');
            }, 3000);
        } catch (error) {
            console.error('Error al actualizar fecha límite:', error);
            setMensajeError(error.message);
        } finally {
            setActualizandoFecha(false);
        }
    };

    const cancelarEdicionFecha = () => {
        setNuevaFechaLimite(fechaLimiteOriginal);
        setEditandoFechaLimite(false);
    };

    const fechaLimiteExpirada = () => {
        if (!selectedQueja || !quejasCompletas[selectedQueja.id]?.fecha_limite) {
            return false;
        }
        const fechaLimiteDate = new Date(quejasCompletas[selectedQueja.id].fecha_limite);
        const ahora = new Date();
        return fechaLimiteDate < ahora;
    };

    const obtenerNombreContactoAsignado = () => {
        if (!selectedQueja) return null;
        return selectedQueja.contacto_asignado || selectedQueja.asignada_a || null;
    };

    const tieneEvidenciaValida = () => {
        if (!selectedQueja || !quejasCompletas[selectedQueja.id]) return false;
        const quejaCompleta = quejasCompletas[selectedQueja.id];
        const filename = quejaCompleta.evidencia_filename;
        if (!filename) return false;
        if (filename === 'MÚLTIPLES_ARCHIVOS') return false;
        if (Array.isArray(filename)) return false;
        if (typeof filename === 'string' && filename.startsWith('[')) return false;
        return true;
    };

    const obtenerNombreArchivo = () => {
        if (!tieneEvidenciaValida()) return null;
        return quejasCompletas[selectedQueja.id].evidencia_filename;
    };

    const handleDescargarEvidencia = () => {
        const filename = obtenerNombreArchivo();
        if (filename) {
            descargarEvidencia(filename);
        } else {
            setMensajeError('No hay archivo disponible para descargar');
        }
    };

    const obtenerIconoArchivo = (filename) => {
        if (!filename) return '📄';
        const extension = filename.split('.').pop()?.toLowerCase();
        switch (extension) {
            case 'pdf': return '📕';
            case 'doc': case 'docx': return '📘';
            case 'jpg': case 'jpeg': case 'png': return '🖼️';
            case 'txt': return '📝';
            default: return '📄';
        }
    };

    const quejaYaAsignada = () => {
        return selectedQueja.estado === 'en_proceso' || selectedQueja.asignada_a || selectedQueja.contacto_asignado;
    };

    const contactoAsignadoNombre = obtenerNombreContactoAsignado();
    const quejaCompleta = quejasCompletas[selectedQueja?.id];
    const fechaLimiteActual = quejaCompleta?.fecha_limite;
    const expirada = fechaLimiteExpirada();

    const mostrarChatTab = selectedQueja && selectedQueja.estado !== 'pendiente' && hasRespondido;

    if (!selectedQueja) return null;

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton className="text-white" style={{ background: '#004892' }}>
                <Modal.Title>
                    Detalles de la {selectedQueja?.tipo_queja === 'identificada' ? 'Sugerencia' : 'Denuncia'} - # {selectedQueja.id}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto', padding: '0' }}>
                <Container fluid>
                    <Nav variant="tabs" className="border-bottom" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                        <Nav.Item>
                            <Nav.Link eventKey="info">Información</Nav.Link>
                        </Nav.Item>
                        {mostrarChatTab && (
                            <Nav.Item>
                                <Nav.Link eventKey="chat">
                                    Seguimiento
                                    {mensajesChat.length > 0 && (
                                        <Badge bg="secondary" className="ms-2">
                                            {mensajesChat.length}
                                        </Badge>
                                    )}
                                </Nav.Link>
                            </Nav.Item>
                        )}
                    </Nav>

                    <Tab.Content>
                        <Tab.Pane eventKey="info" active={activeTab === 'info'}>
                            {selectedQueja && quejasCompletas[selectedQueja.id] ? (
                                <div className="p-3">
                                    <div className="mb-4">
                                        <div className="d-flex justify-content-between align-items-start mb-3">
                                            <div>
                                                <div className="d-flex gap-2 mt-2">
                                                    <span className="badge bg-light text-dark">
                                                        {obtenerTextoTipo(selectedQueja.tipo_queja)}
                                                    </span>
                                                    <span
                                                        className="badge"
                                                        style={{
                                                            backgroundColor: obtenerColorEstado(selectedQueja.estado),
                                                            color: selectedQueja.estado === 'pendiente' ? '#000' : '#fff'
                                                        }}
                                                    >
                                                        {obtenerTextoEstado(selectedQueja.estado)}
                                                    </span>
                                                    {contactoAsignadoNombre && (
                                                        <span className="badge bg-info">
                                                            <i className="bi bi-person-check me-1"></i>
                                                            Asignado a: {contactoAsignadoNombre}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="text-end">
                                                <p className="mb-1">
                                                    <strong>Fecha de entrega:</strong><br />
                                                    {formatearFecha(selectedQueja.fecha_creacion)}
                                                </p>
                                                <p className="mb-0">
                                                    <strong>Fecha de asignación:</strong><br />
                                                    {selectedQueja.fecha_actualizacion && selectedQueja.fecha_actualizacion !== selectedQueja.fecha_creacion
                                                        ? formatearFecha(selectedQueja.fecha_actualizacion)
                                                        : '----'
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="row mt-3">
                                            {quejasCompletas[selectedQueja.id].nombre && (
                                                <div className="col-md-12">
                                                    <strong>Nombre:</strong> {quejasCompletas[selectedQueja.id].nombre}
                                                </div>
                                            )}
                                            {quejasCompletas[selectedQueja.id].correo && (
                                                <div className="col-md-12">
                                                    <strong>Correo:</strong> {quejasCompletas[selectedQueja.id].correo}
                                                </div>
                                            )}
                                            {quejasCompletas[selectedQueja.id].proyecto && (
                                                <div className="col-md-12">
                                                    <strong>Proyecto:</strong> {quejasCompletas[selectedQueja.id].proyecto}
                                                </div>
                                            )}
                                            {quejasCompletas[selectedQueja.id].cargo && (
                                                <div className="col-md-12">
                                                    <strong>Cargo:</strong> {quejasCompletas[selectedQueja.id].cargo}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="mb-4">
                                        <h5 className="border-bottom pb-2 qm-section-title">
                                            Descripción Completa
                                        </h5>
                                        <div className="p-3 bg-light border rounded">
                                            {quejasCompletas[selectedQueja.id].queja.split('\n').map((line, index) => (
                                                <p key={index} className={line ? 'mb-2' : 'mb-0'}>
                                                    {line || <br />}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                    {tieneEvidenciaValida() && (
                                        <div className="mb-4">
                                            <h5 className="border-bottom pb-2">
                                                Evidencia Adjunta
                                            </h5>
                                            <div className="d-flex align-items-center justify-content-between p-3 bg-light border rounded">
                                                <div className="d-flex align-items-center">
                                                    <span className="me-3 fs-4">
                                                        {obtenerIconoArchivo(obtenerNombreArchivo())}
                                                    </span>
                                                    <div>
                                                        <strong>{obtenerNombreArchivo()}</strong>
                                                        <br />
                                                        <small className="text-muted">
                                                            Archivo adjunto - {obtenerNombreArchivo()?.split('.').pop()?.toUpperCase()}
                                                        </small>
                                                    </div>
                                                </div>
                                                <Button
                                                    variant="outline-primary"
                                                    onClick={handleDescargarEvidencia}
                                                    className="ms-3"
                                                >
                                                    <i className="bi bi-download me-2"></i>
                                                    Descargar
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                    {!tieneEvidenciaValida() && (
                                        <div className="mb-4">
                                            <h5 className="border-bottom pb-2 text-muted">
                                                Evidencia Adjunta
                                            </h5>
                                            <div className="p-3 bg-light border rounded text-muted">
                                                <i className="bi bi-file-earmark me-2"></i>
                                                No hay archivos adjuntos
                                            </div>
                                        </div>
                                    )}
                                    {selectedQueja.estado !== 'resuelta' && !expirada && (
                                        <div className="mb-3">
                                            <h5 className="border-bottom pb-2 qm-section-title">
                                                Acciones
                                            </h5>
                                            {mensajeError && !mensajeExito && (
                                                <Alert variant="danger" className="mb-3">
                                                    {mensajeError}
                                                </Alert>
                                            )}
                                            {mensajeExito && (
                                                <Alert variant="success" className="mb-3">
                                                    <i className="bi bi-check-circle-fill me-2"></i>
                                                    {mensajeExito}
                                                </Alert>
                                            )}
                                            {!mostrarBuscador ? (
                                                <div className="d-flex gap-2">
                                                    <button
                                                        className={`btn ${quejaYaAsignada() ? 'btn-secondary' : 'btn-success'}`}
                                                        onClick={() => setMostrarBuscador(true)}
                                                        disabled={quejaYaAsignada()}
                                                    >
                                                        <i className="bi bi-send me-2"></i>
                                                        {quejaYaAsignada() ? 'Ya asignada a una persona' : 'Enviar Sugerencia a Contacto'}
                                                    </button>
                                                    {console.log('Estado de la queja:', selectedQueja.estado)}
                                                    <button
                                                        className={`btn qm-btn-accent ${marcando ? 'disabled' : ''}`}
                                                        onClick={() => handleMarcarComoResuelta(selectedQueja.id)}
                                                        disabled={marcando}
                                                    >
                                                        {marcando ? (
                                                            <>
                                                                <Spinner animation="border" size="sm" className="me-2" />
                                                                Marcarando...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="bi bi-check-circle me-2"></i>
                                                                Marcar como Terminada
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="border rounded p-3 bg-light">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <h6 className="mb-0">
                                                            <i className="bi bi-microsoft me-2"></i>
                                                            Enviar Sugerencia a Contacto:
                                                        </h6>
                                                        <Button variant="outline-secondary" size="sm" onClick={resetearBuscador}>
                                                            ×
                                                        </Button>
                                                    </div>
                                                    {(!contactoSeleccionado || !contactoSeleccionado.nombre) ? (
                                                        <div>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>
                                                                    Lista de Contactos
                                                                    {cargandoContactos && (
                                                                        <Spinner animation="border" size="sm" className="ms-2" />
                                                                    )}
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Buscar por nombre, correo u oficina..."
                                                                    value={terminoBusqueda}
                                                                    onChange={(e) => setTerminoBusqueda(e.target.value)}
                                                                    disabled={cargandoContactos}
                                                                />
                                                                <Form.Text className="text-muted">
                                                                    Escribe al menos 2 caracteres para buscar
                                                                </Form.Text>
                                                            </Form.Group>
                                                            {buscando && (
                                                                <div className="text-center mb-3">
                                                                    <Spinner animation="border" size="sm" className="me-2" />
                                                                    Buscando contactos...
                                                                </div>
                                                            )}
                                                            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                                {contactosFiltrados.length === 0 ? (
                                                                    <div className="text-center p-3 text-muted">
                                                                        {terminoBusqueda.length >= 2 ?
                                                                            'No se encontraron contactos' :
                                                                            'Escribe para buscar contactos'
                                                                        }
                                                                    </div>
                                                                ) : (
                                                                    <ListGroup>
                                                                        {contactosFiltrados.map(contacto => (
                                                                            <ListGroup.Item
                                                                                key={contacto.id}
                                                                                action
                                                                                onClick={() => seleccionarContacto(contacto)}
                                                                                className="d-flex justify-content-between align-items-start"
                                                                            >
                                                                                <div className="flex-grow-1">
                                                                                    <div className="fw-bold">{contacto.nombre}</div>
                                                                                    <small className="text-muted d-block">{contacto.correo}</small>
                                                                                    {contacto.puesto && (
                                                                                        <small className="text-muted">{contacto.puesto}</small>
                                                                                    )}
                                                                                </div>
                                                                                <Badge bg="light" text="dark" className="ms-2">
                                                                                    {contacto.oficina}
                                                                                </Badge>
                                                                            </ListGroup.Item>
                                                                        ))}
                                                                    </ListGroup>
                                                                )}
                                                            </div>
                                                            {contactosFiltrados.length > 0 && (
                                                                <div className="mt-2 text-muted small">
                                                                    <i className="bi bi-info-circle me-1"></i>
                                                                    Mostrando {contactosFiltrados.length} contactos
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <div className="alert alert-info d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <strong>Contacto seleccionado:</strong><br />
                                                                    {contactoSeleccionado.nombre} - {contactoSeleccionado.correo}
                                                                    <br />
                                                                    <small>
                                                                        {contactoSeleccionado.oficina}
                                                                        {contactoSeleccionado.puesto && ` • ${contactoSeleccionado.puesto}`}
                                                                    </small>
                                                                </div>
                                                                <Button variant="outline-secondary" size="sm" onClick={limpiarSeleccion}>
                                                                    Cambiar
                                                                </Button>
                                                            </div>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Fecha Límite (Opcional)</Form.Label>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    value={fechaLimite}
                                                                    onChange={(e) => setFechaLimite(e.target.value)}
                                                                    min={new Date().toISOString().slice(0, 16)}
                                                                />
                                                                <Form.Text className="text-muted">
                                                                    Establece una fecha límite para completar esta tarea
                                                                </Form.Text>
                                                            </Form.Group>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Mensaje Personalizado (Opcional)</Form.Label>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    rows={3}
                                                                    placeholder="Agrega un mensaje personalizado para el contacto..."
                                                                    value={mensajePersonalizado}
                                                                    onChange={(e) => setMensajePersonalizado(e.target.value)}
                                                                />
                                                                <Form.Text className="text-muted">
                                                                    Este mensaje se incluirá en el correo electrónico
                                                                </Form.Text>
                                                            </Form.Group>

                                                            <Form.Group className="mb-3">
                                                                <Form.Label>
                                                                    <i className="bi bi-paperclip me-2"></i>
                                                                    Archivo adjunto (opcional, máximo 5MB)
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="file"
                                                                    onChange={handleArchivoChange}
                                                                    accept="*"
                                                                />
                                                                <Form.Text className="text-muted">
                                                                    Puedes adjuntar cualquier tipo de archivo
                                                                </Form.Text>
                                                                {archivoAdjunto && (
                                                                    <Alert variant="light" className="mt-2">
                                                                        <i className="bi bi-file-earmark me-2"></i>
                                                                        Archivo seleccionado: {archivoNombre}
                                                                        <br />
                                                                        <small>Tamaño: {(archivoAdjunto.size / 1024 / 1024).toFixed(2)} MB</small>
                                                                    </Alert>
                                                                )}
                                                            </Form.Group>

                                                            <div className="alert alert-light border text-start">
                                                                <h6 className="mb-2">
                                                                    <i className="bi bi-envelope me-2"></i>
                                                                    Resumen del envío
                                                                </h6>
                                                                <div className="small">
                                                                    <strong>Destinatario:</strong> {contactoSeleccionado.nombre} ({contactoSeleccionado.correo})<br />
                                                                    <strong>Sugerencia:</strong> #{selectedQueja.id} - {selectedQueja.nombre || 'Anónimo'}<br />
                                                                </div>
                                                            </div>
                                                            <div className="d-flex gap-2">
                                                                <Button
                                                                    variant="success"
                                                                    onClick={enviarQuejaAContacto}
                                                                    disabled={enviando}
                                                                >
                                                                    {enviando ? (
                                                                        <>
                                                                            <Spinner animation="border" size="sm" className="me-2" />
                                                                            Enviando...
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <i className="bi bi-send me-2"></i>
                                                                            Enviar Sugerencia
                                                                        </>
                                                                    )}
                                                                </Button>
                                                                <Button variant="secondary" onClick={resetearBuscador}>
                                                                    Cancelar
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {fechaLimiteActual && (
                                        <div className="mb-4">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h5 className="mb-0">
                                                    <i className="bi bi-clock me-2"></i>
                                                    Fecha Límite
                                                </h5>
                                                {!editandoFechaLimite && selectedQueja.estado !== 'resuelta' && (
                                                    <Button
                                                        variant="outline-secondary"
                                                        size="sm"
                                                        onClick={() => setEditandoFechaLimite(true)}
                                                    >
                                                        <i className="bi bi-pencil me-1"></i>
                                                        Editar
                                                    </Button>
                                                )}
                                            </div>
                                            {editandoFechaLimite ? (
                                                <div className="border rounded p-3 bg-light">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Nueva Fecha Límite</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            value={nuevaFechaLimite}
                                                            onChange={(e) => setNuevaFechaLimite(e.target.value)}
                                                            min={new Date().toISOString().slice(0, 16)}
                                                        />
                                                        <Form.Text className="text-muted">
                                                            Establece una nueva fecha límite para esta tarea
                                                        </Form.Text>
                                                    </Form.Group>
                                                    <div className="d-flex gap-2">
                                                        <Button
                                                            variant="primary"
                                                            onClick={actualizarFechaLimite}
                                                            disabled={actualizandoFecha || nuevaFechaLimite === fechaLimiteOriginal}
                                                        >
                                                            {actualizandoFecha ? (
                                                                <>
                                                                    <Spinner animation="border" size="sm" className="me-2" />
                                                                    Actualizando...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="bi bi-save me-2"></i>
                                                                    Guardar
                                                                </>
                                                            )}
                                                        </Button>
                                                        <Button
                                                            variant="outline-secondary"
                                                            onClick={cancelarEdicionFecha}
                                                            disabled={actualizandoFecha}
                                                        >
                                                            Cancelar
                                                        </Button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className={`p-3 border rounded ${expirada ? 'border-danger bg-danger bg-opacity-10' : 'border-success bg-opacity-10'}`}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <h6 className={`mb-1 ${expirada ? 'text-danger' : 'text-success'}`}>
                                                                <i className={`bi ${expirada ? 'bi-exclamation-triangle' : 'bi-calendar-check'} me-2`}></i>
                                                                {formatearFecha(fechaLimiteActual)}
                                                            </h6>
                                                            {expirada ? (
                                                                <small className="text-danger">
                                                                    <i className="bi bi-exclamation-circle me-1"></i>
                                                                    Esta fecha límite ha expirado
                                                                    <div>
                                                                        El contacto asignado no completó la tarea en el tiempo establecido.
                                                                    </div>
                                                                    <div className="mt-3">
                                                                        <Button
                                                                            variant="outline-danger"
                                                                            onClick={() => setEditandoFechaLimite(true)}
                                                                            size="sm"
                                                                        >
                                                                            <i className="bi bi-pencil me-1"></i>
                                                                            Actualizar Fecha Límite
                                                                        </Button>
                                                                    </div>
                                                                </small>
                                                            ) : (
                                                                <small className="text-success">
                                                                    <i className="bi bi-clock me-1"></i>
                                                                    {(() => {
                                                                        const ahora = new Date();
                                                                        const fechaLimite = new Date(fechaLimiteActual);
                                                                        const diffMs = fechaLimite - ahora;
                                                                        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                                                                        const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                                                                        if (diffDays > 0) {
                                                                            return `Faltan ${diffDays} día${diffDays !== 1 ? 's' : ''} y ${diffHours} hora${diffHours !== 1 ? 's' : ''}`;
                                                                        } else if (diffHours > 0) {
                                                                            return `Faltan ${diffHours} hora${diffHours !== 1 ? 's' : ''}`;
                                                                        } else {
                                                                            return 'Faltan menos de 1 hora';
                                                                        }
                                                                    })()}
                                                                </small>
                                                            )}
                                                        </div>
                                                        {expirada && (
                                                            <Badge bg="danger">
                                                                EXPIRADA
                                                            </Badge>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {selectedQueja.estado === 'resuelta' && (
                                        <>
                                            <div className="alert alert-success">
                                                <i className="bi bi-check-circle-fill me-2"></i>
                                                <strong>Esta {selectedQueja.tipo_queja === 'identificada' ? 'sugerencia' : 'denuncia'} ha sido marcada como resuelta</strong>
                                                <br />
                                                <small>
                                                    Fecha de finalización: {selectedQueja.fecha_actualizacion
                                                        ? formatearFecha(selectedQueja.fecha_actualizacion)
                                                        : '----'
                                                    }
                                                </small>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ) : (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Cargando...</span>
                                    </div>
                                    <p className="mt-2">Cargando detalles de la sugerencia...</p>
                                </div>
                            )}
                        </Tab.Pane>

                        {mostrarChatTab && (
                            <Tab.Pane eventKey="chat" active={activeTab === 'chat'}>
                                <ChatQueja
                                    quejaId={selectedQueja?.id}
                                    show={true}
                                    onHide={() => setActiveTab('info')}
                                    usuarioRol={usuarioRol}
                                    contactoAsignadoNombre={contactoAsignadoNombre}
                                    onMensajeEnviado={cargarMensajesChat}
                                    onQuejaCompletada={(id) => {
                                        const fechaActualizacion = new Date().toISOString();

                                        setSelectedQueja(prev => ({
                                            ...prev,
                                            estado: 'resuelta',
                                            fecha_actualizacion: fechaActualizacion
                                        }));

                                        setQuejasCompletas(prev => ({
                                            ...prev,
                                            [id]: {
                                                ...(prev[id] || {}),
                                                estado: 'resuelta',
                                                fecha_actualizacion: fechaActualizacion
                                            }
                                        }));

                                        if (setQuejas && setQuejasFiltradas) {
                                            setQuejas(prev => prev.map(q =>
                                                q.id === id ? {
                                                    ...q,
                                                    estado: 'resuelta',
                                                    fecha_actualizacion: fechaActualizacion
                                                } : q
                                            ));
                                            setQuejasFiltradas(prev => prev.map(q =>
                                                q.id === id ? {
                                                    ...q,
                                                    estado: 'resuelta',
                                                    fecha_actualizacion: fechaActualizacion
                                                } : q
                                            ));
                                        }

                                        setMensajeExito('Sugerencia marcada como resuelta correctamente');
                                        setTimeout(() => setMensajeExito(''), 3000);
                                    }}
                                />
                            </Tab.Pane>
                        )}
                    </Tab.Content>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default QuejaModal;